import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { IHttpService } from './ihttp.service';

@Injectable()
export class ApiHttpService implements IHttpService {
  constructor(private http: HttpClient) {}

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  public get(url: string): Observable<any> {
    return this.http.get<any>(url).pipe(retry(1), catchError(this.handleError));
  }

  public getWithHeaders(url: string, headers: any): Observable<any> {
    return this.http
      .get<any>(url, headers)
      .pipe(retry(1), catchError(this.handleError));
  }

  // HttpClient API get() method => Fetch one
  getById(url: string, id: number): Observable<any> {
    return this.http
      .get<any>(url + '/' + id)
      .pipe(retry(1), catchError(this.handleError));
  }
  patch(url: string, body: any): Observable<any> {
    ////console.log(url);
    ////console.log(body);

    return this.http
      .patch<any>(url, body)
      .pipe(retry(1), catchError(this.handleError));
  }

  post(url: string, body: any, headers: any): Observable<any> {
    ////console.log('---------------------------');
    ////console.log(url);
    ////console.log(body);
    ////console.log(headers);

    return this.http
      .post<any>(url, body, headers)
      .pipe(retry(1), catchError(this.handleError));
  }

  //Ejemplos

  /*
  public post(url: string, data: any, options?: any) {
    return this.http.post(url, data, options);
  }
  public put(url: string, data: any, options?: any) {
    return this.http.put(url, data, options);
  }
  public delete(url: string, options?: any) {
    return this.http.delete(url, options);
  }
  */

  // Error handling
  handleError(error: {
    error: { message: string };
    status: any;
    message: any;
  }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    //console.log(errorMessage);
    return throwError(errorMessage);
  }
}
